import Resource from '@/api/Resource';

export default class extends Resource {
  $name = 'task-statuses';

  $defaults() {
    return {
      id: null,
      name: '',
      type: '',
      active: 0,
      description: '',
      color: '',
      icon: '',
    };
  }

  get isDone() {
    return this.type === 'success';
  }

  get isClosed() {
    return this.isTypeCancel || this.isTypeSuccess;
  }

  get isTypeNew() {
    return this.type === 'new';
  }

  get isTypeProgress() {
    return this.type === 'progress';
  }

  get isTypeCancel() {
    return this.type === 'cancel';
  }

  get isTypeReopen() {
    return this.type === 'reopen';
  }

  get isTypeAnswered() {
    return this.type === 'answered';
  }

  get isTypeSuccess() {
    return this.type === 'success';
  }

  get isTypeWait() {
    return this.type === 'wait';
  }

  get isTypeFuture() {
    return this.type === 'future';
  }

  get isTypeDeployment() {
    return this.type === 'deployment';
  }

  get isActive() {
    return this.active === 1;
  }
}
